import { render, staticRenderFns } from "./ProfitChart.vue?vue&type=template&id=0f3ab12e&scoped=true"
import script from "./ProfitChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfitChart.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfitChart.vue?vue&type=style&index=0&id=0f3ab12e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3ab12e",
  null
  
)

export default component.exports